import { render, staticRenderFns } from "./ConfirmDeleteMessage.html?vue&type=template&id=0fd119c9&scoped=true&"
import script from "./ConfirmDeleteMessage.js?vue&type=script&lang=js&"
export * from "./ConfirmDeleteMessage.js?vue&type=script&lang=js&"
import style0 from "./ConfirmDeleteMessage.scss?vue&type=style&index=0&id=0fd119c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd119c9",
  null
  
)

export default component.exports